import d1 from '@/assets/images/svg/d1.svg';
import d2 from '@/assets/images/svg/d2.svg';
import d3 from '@/assets/images/svg/d3.svg';
import d4 from '@/assets/images/svg/d4.svg';
import d5 from '@/assets/images/svg/d5.svg';
import d6 from '@/assets/images/svg/d6.svg';

export default {
  model: 'image',
  cards: {
    1: { image: d1 },
    2: { image: d2 },
    3: { image: d3 },
    4: { image: d4 },
    5: { image: d5 },
    6: { image: d6 }
  }
};
